module.exports = __webpack_public_path__ + "static/media/Background-image.307b1b34.jpg";